import React from 'react';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

const crossIco = (
    <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.2" d="M18.5 34C28.165 34 36 26.6127 36 17.5C36 8.3873 28.165 1 18.5 1C8.83502 1 1 8.3873 1 17.5C1 26.6127 8.83502 34 18.5 34Z" stroke="#E0E0E0"/>
        <path d="M24.7225 12.1318L13.2149 22.9818" stroke="#E0E0E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24.7225 22.982L13.2149 12.1319" stroke="#E0E0E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

);



const StyledModal = styled(Modal)`
   z-index: 2400;
   
   .modal-content {
     border-radius: 10px;
   }

  .modal-body {
    padding: 0;
  }
`;

const StyledCloseBtn = styled.button`
  background-color: transparent;
  border: none;
  padding: 5px;
  position: absolute;
  top: -60px;
  cursor: pointer;
`;


const ModalPopup = ({show, onClose, children}) => {

    return (
        <StyledModal show={show} aria-labelledby="contained-modal-title-vcenter" centered>
            <StyledCloseBtn onClick={onClose}>{crossIco}</StyledCloseBtn>
            <Modal.Body>
                {children}
            </Modal.Body>
        </StyledModal>

    );
};

export default ModalPopup;